import React, { useEffect } from "react";
import LockIcon from "@mui/icons-material/LockOutlined";
import { Box, Paper, Avatar, useTheme, FormControl, InputLabel, Input, Grid, LinearProgress } from "@mui/material";
import { Button, useLogin } from "react-admin";

import { userService } from "../../services/UserService";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { config } from "../../config";
import { useLocation } from "react-router-dom";

const useStyles = (theme) => ({
    layout: {
        width: "auto",
        display: "block", // Fix IE11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        paddingTop: theme.spacing(8),
        minHeight: "100vh",
        [theme.breakpoints.up("xs")]: {
            width: "400px",
            marginLeft: "auto",
            marginRight: "auto",
        },
    },
    paper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(3)}`,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        "& .MuiSvgIcon-root": {
            margin: "0",
            alignSelf: "center",
        },
    },
    form: {
        width: "100%", // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    bottomBtn: {
        marginTop: theme.spacing(3),
    },
});

function SignIn() {
    const theme = useTheme();
    const location = useLocation();
    const [showForm, setShowForm] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);

    const classes = useStyles(theme);
    const login = useLogin();

    useEffect(() => {
        if (window.ENV !== "prod") {
            setShowForm(location?.search?.toLowerCase().indexOf("showloginform=true") > 0);
        }
    }, [location]);

    const onGoogleSuccess = (res) => {
        userService.loginGoogle(res.credential).then((user) => {
            if (user?.authenticated) {
                userService.isAuthenticated = true;

                const credentials = {
                    token: user.token,
                };

                login(credentials);
            } else {
                alert("invalid username/password combo");
            }
        });
    };

    const onSignInClick = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        const user = await userService.login(
            document.getElementById("username").value,
            document.getElementById("password").value
        );

        setIsLoading(false);

        if (user.authenticated) {
            login(user);
        }
    };

    const onGoogleFailure = () => {
        alert("GSuite Login Failed");
    };

    return (
        <>
            <Box component="main" sx={classes.layout}>
                <Paper sx={classes.paper}>
                    <Avatar sx={classes.avatar}>
                        <LockIcon />
                    </Avatar>

                    <GoogleOAuthProvider clientId={config.googleClientId}>
                        <GoogleLogin onSuccess={onGoogleSuccess} onFailure={onGoogleFailure} />
                    </GoogleOAuthProvider>
                    <LinearProgress />
                    {showForm === true && (
                        <form className={classes.form} onSubmit={(e) => onSignInClick(e)}>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="username">Username</InputLabel>
                                <Input autoFocus id="username" name="username" autoComplete="username" />
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <Input name="password" type="password" id="password" />
                            </FormControl>

                            { isLoading && <><LinearProgress style={{width:'100%'}} /><br /></> }

                            <Grid container spacing={4}>
                                <Grid item xs={4}>
                                    <Button type="submit" variant="contained" color="primary" label="Sign In" />
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Paper>
            </Box>
        </>
    );
}

export default SignIn;
